import React, { useState } from "react";
import styled from "@emotion/styled";
import { Modal, ModalProps } from "../Modal/Modal";
import { Checkbox } from "../Checkbox/Checkbox";
import { TINTS_OFF_WHITE_20 } from "../../design-tokens";

const UtilityModal = ({
  onConfirm,
  onClose,
  loading,
}: UpdateWarningModalProps) => {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <Modal
      data-testid="utilities-info-edit-modal"
      type="destructive"
      title="Updating the utility company or rate schedule could:"
      onClose={onClose}
      primaryButton={{
        text: "Update utility information",
        onClick: onConfirm,
        disabled: loading || !isChecked,
        testId: "utility-info-modal-update",
      }}
      secondaryButton={{
        text: "Cancel",
        onClick: onClose,
        disabled: loading,
        testId: "utility-info-modal-cancel",
      }}
    >
      <StyledList>
        <li>Void any created offers</li>
        <li>Void any signed agreements</li>
      </StyledList>
      <CheckBoxContainer>
        <Checkbox
          label="I agree to update the utility information"
          name="update-warning-checkbox"
          data-testid="utility-info-modal-agree-to-update"
          onChange={() => setIsChecked(!isChecked)}
          checked={isChecked}
        />
      </CheckBoxContainer>
    </Modal>
  );
};

interface UpdateWarningModalProps extends Pick<ModalProps, "onClose"> {
  onConfirm: () => void;
  loading?: boolean;
  onClose: () => void;
}

const StyledList = styled.ul`
  padding-inline-start: 17px;
  color: ${TINTS_OFF_WHITE_20};
  font-size: 20px;
  font-weight: 100;
  li::marker {
    font-size: 14px;
  }
`;

const CheckBoxContainer = styled.div`
  margin-top: 24px;
`;

export type { UpdateWarningModalProps };

export { UtilityModal };
